import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="pesticides-route"
        path="/pesticides/:culture?/:agent?"
        component={Page} />
];

export default Routes;